import "./assets/scss/main.scss";

import axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { Toast } from "./components/Toast.tsx";
import { EuserProvider } from "./data/providers/EuserProvider.tsx";
import { GroupProvider } from "./data/providers/GroupProvider.tsx";
import { TournamentStateProvider } from "./data/providers/TournamentStateProvider.tsx";
import { WidgetProvider } from "./data/providers/WidgetProvider.tsx";
import { notify } from "./utils/notify.tsx";

window.addEventListener("unhandledrejection", (event) => {
  // AxiosErrors are already handled by the httpClient interceptor
  if (axios.isAxiosError(event.reason)) return;
  console.error("Unhandled promise rejection:", event.reason);
  notify.error("An unexpected error occurred.");
});

window.addEventListener("error", (event) => {
  if (
    // Only handle JS errors from this app (not resource load failures or third-party scripts)
    event.filename?.includes(window.location.origin) &&
    event.error &&
    // AxiosErrors are already handled by the httpClient interceptor
    !axios.isAxiosError(event.error)
  ) {
    console.error("Unhandled error:", event.error);
    notify.error("An unexpected error occurred.");
  }
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <EuserProvider>
      <TournamentStateProvider>
        <GroupProvider>
          <WidgetProvider>
            <BrowserRouter>
              <App />
              <Toast />
            </BrowserRouter>
          </WidgetProvider>
        </GroupProvider>
      </TournamentStateProvider>
    </EuserProvider>
  </React.StrictMode>
);
